import { Box, styled } from "@mui/material";

export const CustomBox = styled(Box)`
	.swiper-wrapper {
		margin: 0 auto;
		width: fit-content;
	}
`;
